import React from 'react';
import Form from "react-bootstrap/Form";
import {Col, Row} from "react-bootstrap";
import Button from "react-bootstrap/Button";
import "react-datepicker/dist/react-datepicker.css";
import ComboFclty from "../../components/inputs/ComboFclty";
import ComboFcltyDtl from "../../components/inputs/ComboFcltyDtl";
import ComboInputPeriodV2 from "../inputs/ComboInputPeriodV2";

const StatisticsDateFacilityRepeaterSensorMessageSearchBox = ({
                                                                searchParam,
                                                                setSearchParam,
                                                                updateList,
                                                                setCurrentPage
                                                              }) => {

  const onChangeStartDate = (date) => {
    setSearchParam((prev) => {
      return {...prev, startDate: date};
    });
  };

  const onChangeStartTime = (hour) => {
    setSearchParam((prev) => {
      return {...prev, searchFromSi: hour};
    });
  };

  const onChangeEndDate = (date) => {
    setSearchParam((prev) => {
      return {...prev, endDate: date};
    });
  };

  const onChangeEndTime = (e) => {
    setSearchParam((prev) => {
      return {...prev, searchToSi: e};
    });
  };

  // 시설
  const onChangeFcltyNo = (e) => {
    e.preventDefault();
    setSearchParam((prev) => {
      return {...prev, searchFcltyNo: e.target.value, searchFcltyDtlNo: ''};
    });
  };

  // 층명
  const onChangeFcltyDtlNo = (e) => {
    e.preventDefault();
    setSearchParam((prev) => {
      return {...prev, searchFcltyDtlNo: e.target.value};
    });
  };

  // 센서명
  const onChangeSensorNm = (e) => {
    e.preventDefault();
    setSearchParam((prev) => {
      return {...prev, searchSensorNm: e.target.value};
    });
  };

  // 메시지 유형
  const onChangeTopicNm = (e) => {
    e.preventDefault();
    setSearchParam((prev) => {
      return {...prev, searchTopicNm: e.target.value};
    });
  };

  const onClickSearch = (e) => {
    e.preventDefault();
    updateList();
    //setCurrentPage(1);
  };


  return (
      <>
        <Form
            id={"searchForm"}
            className={"search-form"}
            onSubmit={onClickSearch}

        >
          <Row className={"justify-content-center"}>
            <Col md={12}>
              <Row className={"justify-content-start"}>
                <Col md={10}>
                  <Row className={"gy-2"}>
                    {/*<Col md={9} className={""}>*/}
                    <Col xxl={6} xl={12} lg={12} md={12}>
                      <ComboInputPeriodV2
                          propSearchParam={searchParam}
                          propOnChangeStart={onChangeStartDate}
                          propOnChangeEnd={onChangeEndDate}
                          propOnChangeStartHour={onChangeStartTime}
                          propOnChangeEndHour={onChangeEndTime}
                          // propLabelSize={1}
                          // propInputSize={5}
                      />
                    </Col>
                    {/*<Col md={3} className={""}>*/}
                    <Col xxl={3} xl={6} lg={6} md={12}>
                      <ComboFclty
                          propOnChange={onChangeFcltyNo}
                      />
                    </Col>

                    {/*<Col md={3} className={""}>*/}
                    <Col xxl={3} xl={6} lg={6} md={12}>
                      <ComboFcltyDtl
                          propFilterFclty={searchParam.searchFcltyNo}
                          propFilterFcltyDtl={searchParam.searchFcltyDtlNo}
                          propOnChange={onChangeFcltyDtlNo}
                      />
                    </Col>

                    {/*<Col md={3} className={""}>*/}
                    <Col xxl={3} xl={6} lg={6} md={12}>
                      <Form.Group as={Row} controlId="formFireCondition">
                        <Form.Label
                            className={`col-form-label label text-end`}
                            style={{width: "100px"}}
                        >
                          센서명
                        </Form.Label>
                        <Col>
                          <Form.Control
                              type="text"
                              placeholder=""
                              className={"input-search"}
                              onChange={onChangeSensorNm}
                          />
                        </Col>
                      </Form.Group>
                    </Col>

                    {/*<Col md={3} className={""}>*/}
                    <Col xxl={3} xl={6} lg={6} md={12}>
                      <Form.Group as={Row} controlId="formFireCondition">
                        <Form.Label
                            className={`col-form-label label text-end`}
                            style={{width: "100px"}}
                        >
                          메시지유형
                        </Form.Label>
                        <Col>
                          <Form.Control
                              type="text"
                              placeholder=""
                              className={"input-search"}
                              onChange={onChangeTopicNm}
                          />
                        </Col>
                      </Form.Group>
                    </Col>
                  </Row>
                </Col>

                <Col md={2}
                     className={"text-center search-btn-container d-flex align-items-center justify-content-center"}>
                  <Button
                      type="submit"
                      className={"search-btn"}
                      style={{width: "100px"}}
                  >
                    검색
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </Form>
      </>
  );
};

export default StatisticsDateFacilityRepeaterSensorMessageSearchBox;
